import { useQuery } from '@tanstack/react-query'

import { STALE_TIME } from './common'
import * as PlaceRatingKeys from '../reactQueryKeys/placeRating'

import { getGooglePlaceRating } from 'tripPlanner/api/places'

export const usePlaceRating = (placeId: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: PlaceRatingKeys.googlePlaceRating(placeId),
    queryFn: () => getGooglePlaceRating(placeId),
    staleTime: STALE_TIME,
    select: (data) => data,
    enabled,
  })
}
